const wrap: React.CSSProperties = {
  maxWidth: 820,
  margin: "0 auto",
  padding: "48px 20px 72px",
  lineHeight: 1.7,
  color: "#333",
};

export default function Privacy() {
  return (
    <main style={wrap}>
      <title>Privacy Policy | Your Energy Guru</title>
      <meta
        name="description"
        content="How Your Energy Guru collects, uses, and shares information when you request solar quotes or use this site."
      />
      <link rel="canonical" href="https://yourenergyguru.com/privacy" />

      <h1>Privacy Policy</h1>
      <p>
        <em>Effective date: July 24, 2026</em>
      </p>

      <p>
        Your Energy Guru ("we," "us") operates yourenergyguru.com, a free solar
        education and quote-matching service for homeowners. This policy
        explains what information we collect, how we use it, and the choices
        you have. We've written it in plain English on purpose.
      </p>

      <h2>Information we collect</h2>
      <p>
        <strong>Information you give us.</strong> When you request a quote,
        use a calculator, subscribe to email updates, or contact us, you may
        provide your name, email address, phone number, street address,
        details about your home and electric bill, and similar information.
      </p>
      <p>
        <strong>Information collected automatically.</strong> Like most
        websites, we receive basic technical data such as your IP address,
        browser and device type, pages viewed, and referring URLs, including
        through cookies and similar technologies used by our hosting and
        analytics providers.
      </p>

      <h2>How we use and share your information — read this part</h2>
      <p>
        Our service is connecting homeowners who request quotes with solar
        installers and related service providers. <strong>If you submit a
        quote request, we share the information in that request with one or
        more partner providers so they can contact you</strong> — that is the
        product, and it is how we are compensated. Under some state privacy
        laws, providing lead information to partners in exchange for
        compensation is considered a "sale" or "sharing" of personal
        information. We do not sell your information to unrelated data
        brokers, and we do not share form submissions with anyone other than
        the partners needed to fulfill your request and the vendors that run
        our infrastructure (such as hosting, database, and email services).
      </p>
      <p>
        By submitting a quote form, you also provide the contact consent
        described on that form: we and our partner providers may contact you
        by phone, text message, or email — including through automated
        technology — at the contact details you provide. Consent is not a
        condition of any purchase, and you can revoke it at any time by
        telling us or the contacting provider.
      </p>
      <p>Other routine uses: operating and improving the site, sending email
        updates you signed up for (every email includes an unsubscribe link),
        preventing fraud and abuse, and complying with law.</p>

      <h2>Data retention & security</h2>
      <p>
        We keep quote submissions and subscriber records for as long as needed
        to operate the service and meet legal obligations, then delete or
        anonymize them. We use reputable infrastructure providers (Google
        Firebase) and reasonable safeguards, though no internet service can
        guarantee perfect security.
      </p>

      <h2>Your rights and choices</h2>
      <p>
        Depending on your state, you may have the right to access, correct, or
        delete personal information we hold about you, and to opt out of the
        "sale" or "sharing" of your information. To exercise any of these
        rights — including a request that we not share a submission you've
        already made — reach us through our <a href="/contact">contact page</a>.
        We will verify and honor requests as required by applicable law,
        without discriminating against you for making them.
      </p>

      <h2>Children</h2>
      <p>
        This site is intended for homeowners and is not directed to anyone
        under 18. We do not knowingly collect information from children.
      </p>

      <h2>Changes & contact</h2>
      <p>
        If we make material changes to this policy we will update the
        effective date above. Questions? Reach us any time through our{" "}
        <a href="/contact">contact page</a>.
      </p>
    </main>
  );
}
